export { PROVIDER_DISPLAY_NAME } from '@/api/queries/settings/constants';
import { SocialProvider } from '@/api/queries/settings/constants';

export const RETURN_TO_KEY = 'oauth_return_to';
export const OAUTH_PROVIDER_KEY = 'oauth_provider';

export function redirectToOAuth(url: string, provider: SocialProvider) {
  sessionStorage.setItem(RETURN_TO_KEY, window.location.pathname);
  sessionStorage.setItem(OAUTH_PROVIDER_KEY, provider);
  window.location.href = url;
}

export function getSafeReturnTo(fallback = '/settings/connect'): string {
  const stored = sessionStorage.getItem(RETURN_TO_KEY) ?? fallback;
  if (!stored.startsWith('/') || stored.startsWith('//')) return fallback;
  return stored;
}

function isSocialProvider(value: string): value is SocialProvider {
  return Object.values<string>(SocialProvider).includes(value);
}

export function getOAuthProvider(
  fallback: SocialProvider = SocialProvider.INSTAGRAM
): SocialProvider {
  const stored = sessionStorage.getItem(OAUTH_PROVIDER_KEY);
  if (stored && isSocialProvider(stored)) return stored;
  return fallback;
}
